'use client';

import { c as _c } from "react/compiler-runtime";
import { type Space, Types } from '@shared/all/domains/spaces';
import { type Upload } from '@shared/all/domains/uploads';
import useSpace from '@shared/utils/hooks/useSpace';
import Link from 'next/link';
import { useState } from 'react';
import { type RouterOutputs } from '../../utils/trpc';
import SpaceMedia from '../common/Media';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
import PostAlertsMenuItem from '../pages/space/PostAlertsMenuItem';
type Props = {
  copyLinkHandler: () => void;
  slug: string;
  loggedIn: boolean;
  filtered: boolean | undefined;
  filterChangeHandler: (type: 'add' | 'remove') => void;
  reportClickHandler: () => void;
  types: Space['types'];
  isInvited: boolean;
  joinHandler: () => void;
  leaveHandler: () => void;
  openEmbedModal: () => void;
  closeHandler: () => void;
  uploads: Upload[] | undefined;
  space: RouterOutputs['spaces']['get'];
  editHandler?: () => void;
  showHistoryLink?: boolean;
  // The board header's menu: a member gets the Enable/Disable alerts row.
  isBoardLayout?: boolean;
  // Board spaces only: replays the development board tour
  onTakeTour?: () => void;
};
const SpaceDropdown = props => {
  const $ = _c(75);
  const {
    isOwner,
    isModerator
  } = useSpace();
  const [showSpaceMedia, setShowSpaceMedia] = useState(false);
  let t0;
  if ($[0] !== props.isInvited || $[1] !== props.joinHandler || $[2] !== props.space.membership || $[3] !== props.space.types) {
    t0 = !props.space.membership && !props.space.types.includes(Types.PRIVATE) && (!props.space.types.includes(Types.INVITE) && !props.space.types.includes(Types.PAID) || props.isInvited) && <button className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" onClick={props.joinHandler}>Join Space</button>;
    $[0] = props.isInvited;
    $[1] = props.joinHandler;
    $[2] = props.space.membership;
    $[3] = props.space.types;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== props.isInvited || $[6] !== props.joinHandler || $[7] !== props.space.membership || $[8] !== props.space.types) {
    t1 = !props.space.membership && props.space.types.includes(Types.INVITE) && !props.isInvited && <div className=""><button className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" onClick={props.joinHandler}>Join Space</button><span className="ml-2">This is an invite-only community</span></div>;
    $[5] = props.isInvited;
    $[6] = props.joinHandler;
    $[7] = props.space.membership;
    $[8] = props.space.types;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== isOwner || $[11] !== props.leaveHandler || $[12] !== props.space) {
    t2 = props.space.membership && !props.space.types.includes(Types.PRIVATE) && <button title="Leave Space" className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" disabled={isOwner(props.space)} onClick={props.leaveHandler}>Leave Space</button>;
    $[10] = isOwner;
    $[11] = props.leaveHandler;
    $[12] = props.space;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== isOwner || $[15] !== props.leaveHandler || $[16] !== props.space) {
    t3 = props.space.membership?.expires === null && props.space.types.includes(Types.PAID) && <button title="Cancel Membership" className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" disabled={isOwner(props.space)} onClick={props.leaveHandler}>Cancel Membership</button>;
    $[14] = isOwner;
    $[15] = props.leaveHandler;
    $[16] = props.space;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== props.space.membership || $[19] !== props.space.types) {
    t4 = props.space.membership && props.space.membership.expires !== null && new Date(props.space.membership.expires ?? 0) >= new Date() && props.space.types.includes(Types.PAID) && <button className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" disabled={true}>{`Expires on ${new Date(props.space.membership.expires ?? 0).toLocaleDateString()}`}</button>;
    $[18] = props.space.membership;
    $[19] = props.space.types;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== showSpaceMedia) {
    t5 = <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" onClick={() => setShowSpaceMedia(!showSpaceMedia)}>Space Media</button>;
    $[21] = showSpaceMedia;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const t6 = `/s/${props.space.spaceSlug}/history`;
  let t7;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="ml-2">Space History</span>;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t6) {
    t8 = <Link href={t6} className="flex items-center rounded-md px-2 py-2.5 md:hidden">{t7}</Link>;
    $[24] = t6;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== props.copyLinkHandler) {
    t9 = <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={props.copyLinkHandler}>Copy link to Space</button>;
    $[26] = props.copyLinkHandler;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== props.openEmbedModal) {
    t10 = <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={props.openEmbedModal}>Embed Space</button>;
    $[28] = props.openEmbedModal;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== props) {
    t11 = props.loggedIn && props.slug !== "factiii" && <>{!props.filtered && <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={() => props.filterChangeHandler("add")}>Add Space as filter</button>}{props.filtered && <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={() => props.filterChangeHandler("remove")}>Remove Space as filter</button>}</>;
    $[30] = props;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== isOwner || $[33] !== props) {
    t12 = isOwner(props.space) && props.editHandler && <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={() => {
      props.closeHandler();
      props.editHandler?.();
    }}>Edit Space</button>;
    $[32] = isOwner;
    $[33] = props;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== props.closeHandler || $[36] !== props.isBoardLayout || $[37] !== props.isInvited || $[38] !== props.slug || $[39] !== props.space.membership) {
    t13 = props.isBoardLayout && props.space.membership && !props.isInvited && <PostAlertsMenuItem spaceSlug={props.slug} enabled={props.space.membership.postAlerts} closeHandler={props.closeHandler} />;
    $[35] = props.closeHandler;
    $[36] = props.isBoardLayout;
    $[37] = props.isInvited;
    $[38] = props.slug;
    $[39] = props.space.membership;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== isModerator || $[42] !== isOwner || $[43] !== props.slug || $[44] !== props.space) {
    t14 = (isOwner(props.space) || isModerator(props.space)) && <><Link href={`/s/${props.slug}/manage/${isOwner(props.space) ? "availability" : "moderators"}`}><button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light">Manage Space</button></Link><Link href={`/moderation/${props.slug}`}><button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light">Moderation center</button></Link></>;
    $[41] = isModerator;
    $[42] = isOwner;
    $[43] = props.slug;
    $[44] = props.space;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== props.loggedIn || $[47] !== props.showHistoryLink || $[48] !== props.slug) {
    t15 = props.loggedIn && props.showHistoryLink && <Link href={`/s/${props.slug}/history`}><button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light">History</button></Link>;
    $[46] = props.loggedIn;
    $[47] = props.showHistoryLink;
    $[48] = props.slug;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] !== props) {
    t16 = false && props.onTakeTour && <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={() => {
      props.closeHandler();
      props.onTakeTour?.();
    }}>Take the board tour</button>;
    $[50] = props;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== props.reportClickHandler) {
    t17 = <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={props.reportClickHandler}>Report Space</button>;
    $[52] = props.reportClickHandler;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== props.uploads || $[55] !== showSpaceMedia) {
    t18 = showSpaceMedia && <Modal closeHandler={() => setShowSpaceMedia(false)}><ModalHeader><h2>Space Media</h2></ModalHeader><ModalContent>{props.uploads ? <SpaceMedia data={props.uploads} /> : <div className="text-center text-textSecondary/70">No media files to show</div>}</ModalContent></Modal>;
    $[54] = props.uploads;
    $[55] = showSpaceMedia;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== t0 || $[58] !== t1 || $[59] !== t10 || $[60] !== t11 || $[61] !== t12 || $[62] !== t13 || $[63] !== t14 || $[64] !== t15 || $[65] !== t16 || $[66] !== t17 || $[67] !== t18 || $[68] !== t2 || $[69] !== t3 || $[70] !== t4 || $[71] !== t5 || $[72] !== t8 || $[73] !== t9) {
    t19 = <div className="w-48 rounded-md border border-ds-border-standard bg-background-primary p-2 shadow-md">{t0}{t1}{t2}{t3}{t4}{t5}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}</div>;
    $[57] = t0;
    $[58] = t1;
    $[59] = t10;
    $[60] = t11;
    $[61] = t12;
    $[62] = t13;
    $[63] = t14;
    $[64] = t15;
    $[65] = t16;
    $[66] = t17;
    $[67] = t18;
    $[68] = t2;
    $[69] = t3;
    $[70] = t4;
    $[71] = t5;
    $[72] = t8;
    $[73] = t9;
    $[74] = t19;
  } else {
    t19 = $[74];
  }
  return t19;
};
export default SpaceDropdown;